import App from 'App';
import React from 'react';
import ReactDOM from 'react-dom';

import * as serviceWorker from './serviceWorker';

// Apply saved theme before first render (prevents flash)
const savedTheme = localStorage.getItem('theme') || 'dark-black';
document.documentElement.setAttribute('data-theme', savedTheme);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
